(() => {
  function init(root) {
    root.querySelectorAll('[data-hero-carousel]').forEach((hero) => {
      if (hero.dataset.carouselReady) return;
      hero.dataset.carouselReady = 'true';
      const slides = [...hero.querySelectorAll('[data-hero-slide]')];
      const dots = [...hero.querySelectorAll('[data-hero-dot]')];
      const copy = hero.querySelector('[data-hero-copy]');
      const brand = copy.querySelector('[data-hero-copy-brand]');
      const headline = copy.querySelector('[data-hero-copy-headline]');
      const features = copy.querySelector('[data-hero-copy-features]');
      const note = copy.querySelector('[data-hero-copy-note]');
      let current = 0;
      const renderHeadline = (value) => {
        headline.replaceChildren();
        [value.line1, value.line2].forEach((line) => {
          const span = document.createElement('span');
          span.textContent = line;
          headline.append(span);
        });
      };
      const renderSeparated = (node, value) => {
        const parts = value.split(' · ').filter(Boolean);
        node.replaceChildren();
        node.hidden = parts.length === 0;
        node.setAttribute('aria-label', parts.join(', '));
        parts.forEach((part, index) => {
          const span = document.createElement('span');
          span.textContent = part;
          node.append(span);
          if (index < parts.length - 1) {
            const separator = document.createElement('span');
            separator.className = 'hero-copy__separator';
            separator.setAttribute('aria-hidden', 'true');
            separator.textContent = '•';
            node.append(separator);
          }
        });
      };
      const syncCopy = (slide) => {
        brand.textContent = slide.dataset.heroCopyBrand;
        renderHeadline({ line1: slide.dataset.heroCopyLineOne, line2: slide.dataset.heroCopyLineTwo });
        renderSeparated(features, slide.dataset.heroCopyFeatures);
        renderSeparated(note, slide.dataset.heroCopyNote);
      };
      const show = (index) => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => { slide.classList.toggle('is-active', i === current); slide.setAttribute('aria-hidden', String(i !== current)); });
        dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === current)));
        syncCopy(slides[current]);
        hero.querySelector('[data-hero-status]').textContent = 'Image ' + (current + 1) + ' of ' + slides.length;
      };
      hero.querySelector('[data-hero-next]').addEventListener('click', () => show(current + 1));
      dots.forEach((dot, i) => dot.addEventListener('click', () => show(i)));
      hero.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); show(current + (event.key === 'ArrowRight' ? 1 : -1)); }
      });
      let start;
      hero.addEventListener('touchstart', (event) => { start = event.touches.length === 1 ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null; }, { passive: true });
      hero.addEventListener('touchend', (event) => {
        if (!start) return;
        const dx = event.changedTouches[0].clientX - start.x;
        const dy = event.changedTouches[0].clientY - start.y;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.3) show(current + (dx < 0 ? 1 : -1));
        start = null;
      }, { passive: true });
      hero.addEventListener('touchcancel', () => { start = null; }, { passive: true });
      show(0);
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
